import TextAreaField from "../../applicationUi/components/intake/TextAreaField";

const PostAppointmentSection = ({ formData, handleChange, isReadOnly = false }) => (
  <section className="space-y-8">
    <div className="space-y-2">
      <h2 className="text-xl font-semibold text-foreground">I - Post Appointment Expectations</h2>
      <p className="text-sm text-muted-foreground">
        What you hope to achieve from this appointment.
      </p>
    </div>
    <TextAreaField
      label="What are you hoping we will be able to provide to you after this appointment with us?"
      name="postAppointmentExpectations"
      value={formData.postAppointmentExpectations}
      onChange={handleChange}
      placeholder="e.g. recommendation for home management, service at this clinic, referral to another agency"
          readOnly={isReadOnly}
    />
  </section>
);

export default PostAppointmentSection;
